import * as angular from "angular";

export class SearchUtils {
    public searchText = "";
    public placeholder = "";

    public searchChanged: any = null;
    public emptySearchQuery: any = (): any[] => [];
    public searchQuery = this.emptySearchQuery;
    public selectedItemChange = (item: any): void => {};

    searchAvailable(): boolean {
        return this.searchChanged || this.searchQuery !== this.emptySearchQuery;
    }

    setSearchBar(
        newPlaceholder: string,
        searchChangedFn?: any,
        searchQueryFn?: any,
        keepText?: boolean
    ): void {
        this.placeholder = newPlaceholder;
        if (!keepText) {
            this.searchText = "";
        }

        this.searchChanged = searchChangedFn ? searchChangedFn : null;
        this.searchQuery = searchQueryFn
            ? searchQueryFn
            : this.emptySearchQuery;
    }

    isSearching(): boolean {
        return this.searchText !== "";
    }
}

angular.module("vcHelper").service("SearchUtils", SearchUtils);
